import React from 'react';
import './section3.css'
import Title from '../common/title';
import Text from '../common/text';
const Sec3 = () => {
    return (<>
    <section className='sec3'>
 <Title title='Where It Began' t='title' />
            <Text text='At Golden Hills, we believe in creating more than just homes – we build vibrant communities nestled in the beauty of nature. Our dedication to quality craftsmanship, sustainable design, and exceptional service ensures that each property offers comfort, luxury, and peace of mind. Whether you re seeking a serene escape or a modern family home, Golden Hills is where your perfect living experience begins.' x='text'  />
    </section>
    </>  );
}
 
export default Sec3;